// checks the promptObject before submitting it to the firestore
// works for /create and /edit
// returns an error if the promptObject does not pass the inspection
// when you make changes here, be sure to make the same changes in
// promptValidation() in Firestore Security Rules
import { checkPromptRules, formatViolationsForUser } from './promptRules';

export default promptObject => {
  const { title, text, iam, lookingfor, tags } = promptObject;
  const errors = {};
  if (title.length === 0) {
    errors.title = 'Title is empty!';
  } else if (title.length < 6) {
    errors.title = 'Title is too short!';
  }
  if (title.length > 300) {
    errors.title = 'Title has to be 300 characters or less!';
  }
  // text is a draft-js EditorState on /create and /edit, and a plain string on
  // the admin bulk-upload path. `typeof null === 'object'`, so the null case
  // has to be excluded explicitly or it throws a TypeError that gets reported
  // as a firebase error with an undefined message.
  let modText = text;
  if (text && typeof text === 'object') {
    modText = text.getCurrentContent().getPlainText();
  } else if (typeof text !== 'string') {
    modText = '';
  }
  if (modText.length === 0) {
    errors.text = 'Text is missing! Write something!';
  } else if (modText.length < 6) {
    errors.text = 'Text is too short! Write more!';
  }
  const genders = [
    'all',
    'male',
    'female',
    'transwoman',
    'transman',
    'non-binary'
  ];
  if (!genders.includes(iam)) {
    errors.iam = 'I am is invalid';
  }
  if (!genders.includes(lookingfor)) {
    errors.lookingfor = 'Looking for is invalid';
  }

  // The site rules (eropenpal.com/rules), enforced before a prompt can go live.
  // Only on this path and deliberately NOT in the draft check below: a work in
  // progress is allowed to be messy, and a draft is not public.
  // promptModerationFunctions.js runs the same engine again on write - that is
  // the actual enforcement, since anyone can write to firestore directly. This
  // check exists so an author gets an inline reason now instead of a silent
  // takedown a minute later.
  const { verdict, violations } = checkPromptRules({
    title,
    text: modText,
    tags
  });
  if (verdict === 'block') {
    errors.rules = formatViolationsForUser(violations);
  }

  if (Object.keys(errors).length === 0) {
    return null;
  }
  errors.type = 'manmade';
  throw errors;
};

// checks the prompt before it is saved as a draft
// makes sure the prompt has a title of at least 6 characters
export const checkPromptObjectBeforeDraft = promptObject => {
  const { title } = promptObject;
  const errors = {};
  if (title.length === 0) {
    errors.title = 'Title is empty!';
  } else if (title.length < 6) {
    errors.title = 'Title is too short!';
  }
  if (title.length > 300) {
    errors.title = 'Title has to be 300 characters or less!';
  }
  if (Object.keys(errors).length === 0) {
    return null;
  }
  errors.type = 'manmade';
  throw errors;
};
